<template>
  <div>
    <HeaderView :title="$t('bank.title')" />
    <div class="view-page">
      <van-form @submit="bindCard">
        <van-cell-group>
          <van-field
            v-model="bank"
            :label="$t('bank.bankname')"
            :placeholder="$t('bank.banknameple')"
            :rules="[{ required: true}]"
          />
          <van-field
            v-model="username"
            :label="$t('bank.pername')"
            :placeholder="$t('bank.pernameple')"
            :rules="[{ required: true}]"
          />
          <van-field
            v-model="bankid"
            :label="$t('bank.accountNo')"
            :placeholder="$t('bank.accountNople')"
            :rules="[{ required: true}]"
          />
          <van-field
            v-model="mobile"
            :label="$t('bank.ifsc')"
            :placeholder="$t('bank.ifscple')"
            :rules="[{ required: true}]"
          />
          <van-field
            v-model="pwd"
            :label="$t('bank.pwd')"
            type="password"
            :placeholder="$t('bank.pwdple')"
            :rules="[{ required: true}]"
          />
        </van-cell-group>

        <div style="margin: 16px">
          <van-button class="btn" native-type="submit"
            >{{ $t('common.save') }}</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import HeaderView from "@/components/Header/index.vue";
export default {
  name: "BankInfoView",
  components: { HeaderView },
  data() {
    return {
      banks: [],
      showBank: false,
      userInfo: {},
      bankid: null,
      username: null,
      mobile: null,
      bank: null,
      bank_code: null,
      pwd:null,
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    bindCard() {
      if (this.userInfo.bankid) {
        this.$toast(this.$t("setting.band_account_tip"));
        return true;
      }
      if (this.bank === "" || this.bank === null || this.bank === undefined) {
        this.$toast.fail(this.$t("setting.band_name_tip"));
        return false;
      }

      if (this.userInfo.bankid) {
        this.$toast(this.$t("setting.band_account_tip"));
        return true;
      }

      if (this.username === "") {
        this.$toast(this.$t("setting.username_place"));
        return false;
      }

      if (this.mobile === "") {
        this.$toast(this.$t("setting.mobile_place"));
        return false;
      }

      this.$http({
        method: "post",
        data: {
          bankid: this.bankid,
          bank: this.bank,
          bank_code: this.bank_code,
          username: this.username,
          mobile: this.mobile,
          password:this.pwd
        },
        url: "user_set_bank",
      }).then((res) => {
        if (res.code === 200) {
          this.$router.push({ path: "/mine" });
          this.$toast(res.msg);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    showSelectBanks() {
      this.showBank = true;
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getBankList() {
      this.$http({
        method: "get",
        url: "sys_get_banks",
      }).then((res) => {
        if (res.code === 200) {
          this.banks = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    onConfirm(value) {
      this.bank = value.text;
      this.bank_code = value.value;
      this.showBank = false;
    },
    onCancel() {
      this.showBank = false;
    },
    getUserBankInfo() {
      this.$http({
        method: "get",
        url: "user_get_bank",
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.is_bind = true;
          } else {
            this.is_bind = false;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/login" });
    } else {
      this.getUserInfo();
      this.getBankList();
      this.getUserBankInfo();
    }
  },
};
</script>

<style></style>
